import { render } from "./JMTablePaginate.vue?vue&type=template&id=5a4608a6&ts=true&lang=pug"
import script from "./JMTablePaginate.vue?vue&type=script&lang=ts"
export * from "./JMTablePaginate.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__